/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_CAMPAIGN_ID](state, campaignId) {
    state.campaignId = campaignId;
  },

  [types.SET_PASSCODE](state, passcode) {
    state.passcode = passcode;
  },

  [types.SET_CAMPAIGN_IS_VALID](state, isValid) {
    state.isCampaignValid = isValid;
  },

  [types.SET_PASSCODE_IS_VALID](state, isValid) {
    state.isPasscodeValid = isValid;
  },

  [types.SET_PALETTE_ID](state, paletteId) {
    state.paletteId = paletteId;
  },

  [types.SET_EXPIRATION_DATE](state, expirationDate) {
    state.expirationDate = expirationDate;
  },

  [types.SET_CAMPAIGN_IS_EXPIRED](state, isCampaignExpired) {
    state.isCampaignExpired = isCampaignExpired;
  },
};

export default mutations;
